<template>
  <page :title="displayTitle" :breadcrumb="breadcrumbRef">
    <v-card class="pa-3">
      <v-layout row wrap v-if="!noAction">
        <!-- 2021-03-10 LYT - If menu items less or equal 10, display the menu items in 1 column only. -->
        <v-flex xs12 v-if="getTotalMenuItems <= 10">
          <v-list two-line subheader dense>
            <template v-for="item in menuRef.children">
              <v-list-item :key="item.name" @click="launchApp(item.name, item.route)" v-if="visablity(item.route)">
                <v-list-item-action>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <v-icon v-else>{{ item.route ? 'mdi-launch' : 'mdi-folder' }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="hasQuickLaunch">
                  <v-btn icon ripple @click.stop="toggleQuickLaunch(item.name)">
                    <v-icon color="primary">{{ checkQuickLaunch(item.name) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-flex>
        <!-- 2021-03-10 LYT - If menu items more than 10, split the menu items evenly and display them in 2 columns. -->
        <v-flex lg6 md6 xs12 v-if="getTotalMenuItems > 10">
          <v-list two-line subheader dense>
            <template v-for="item in filteredItems(1, 2)">
              <v-list-item :key="item.name" @click="launchApp(item.name, item.route)" v-if="visablity(item.route)">
                <v-list-item-action>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <v-icon v-else>{{ item.route ? 'mdi-launch' : 'mdi-folder' }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="hasQuickLaunch">
                  <v-btn icon ripple @click.stop="toggleQuickLaunch(item.name)">
                    <v-icon color="primary">{{ checkQuickLaunch(item.name) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-flex>
        <v-flex lg6 md6 xs12 v-if="getTotalMenuItems > 10">
          <v-list two-line subheader dense>
            <template v-for="item in filteredItems(2, 2)">
              <v-list-item :key="item.name" @click="launchApp(item.name, item.route)" v-if="visablity(item.route)">
                <v-list-item-action>
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  <v-icon v-else>{{ item.route ? 'mdi-launch' : 'mdi-folder' }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                  <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="hasQuickLaunch">
                  <v-btn icon ripple @click.stop="toggleQuickLaunch(item.name)">
                    <v-icon color="primary">{{ checkQuickLaunch(item.name) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout column v-else>
        <v-flex> No Action is found for this menu option. Please contact the System Administrator for help. </v-flex>
      </v-layout>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import Routable from '@/mixins/routable'

export default {
  data() {
    return {
      displayTitle: '',
      menuRef: undefined,
      breadcrumbRef: [],
      // noAction is use to define menu with no children and is not a route link (basically a deadend)
      noAction: true
    }
  },
  computed: {
    ...mapGetters(['getInternalMenu', 'derieveBreadcrumb']),
    hasQuickLaunch() {
      if (this.$store.state.widgets.quickLaunch.init === 1) {
        return true
      } else {
        return false
      }
    },
    getTotalMenuItems() {
      return this.menuRef.children.length
    }
  },
  watch: {
    id: {
      handler: 'handleRoute',
      immediate: true
    }
  },
  methods: {
    handleRoute() {
      if (this.id) {
        this.menuRef = this.getInternalMenu(this.id)
        if (this.menuRef) {
          if (this.menuRef.route) {
            // It is a routable menu
            this.$router.push({ name: this.menuRef.name })
          } else {
            // Set display title
            this.displayTitle = this.menuRef.text
            this.breadcrumbRef = this.derieveBreadcrumb(this.menuRef.key)
            if (this.menuRef.children) {
              this.noAction = false
            } else {
              // Reach here means no route no child
              this.noAction = true
            }
          }
        } else {
          // cannot find, push to 404
          this.$router.push({ name: 'notfound' })
        }
      }
    },
    visablity(route) {
      if (route || typeof route !== 'undefined') {
        return route
      }
      return true
    },
    filteredItems(column, columns) {
      const total = this.menuRef.children.length // How many items
      const gap = Math.ceil(total / columns) // How many per col
      let top = gap * column // Top of the col
      const bottom = top - gap
      top -= 1 // Adjust top back down one
      return this.menuRef.children.filter((item) => this.menuRef.children.indexOf(item) >= bottom && this.menuRef.children.indexOf(item) <= top) // Return the items for the given col
    }
  },
  props: ['id'],
  mixins: [Routable]
}
</script>

<style>
</style>
